/**
 * Contains all of the actions that can happen in the App.
 */

import keyMirror from 'keymirror'

export const ROOT_URL = '/myaccount/transfer/fx/fees'
export const PREVIEW_URL = '/myaccount/transfer/fx/fees/send/external/xb?'
export const CHANGE_EVENT = 'CHANGE'

export const ActionTypes = keyMirror({
  INITIALIZE: null,

  EXIT_TO_P2P: null,

  // TODO: REQUESTED/RECEIVED at end?
  // CURRENCY_CODE_LIST_REQUESTED
  // CURRENCY_CODE_LIST_RECEIVED
  REQUEST_CURRENCY_CODE_LIST: null,
  RECEIVED_CURRENCY_CODE_LIST: null,
  RECEIVED_DESTINATION_PRIMARY_CURRENCY_CODE: null,

  CHANGE_ORIGIN_COUNTRY: null,
  CHANGE_DESTINATION_COUNTRY: null,
  CHANGE_ORIGIN_CURRENCY_CODE: null,
  CHANGE_DESTINATION_CURRENCY_CODE: null,

  // recipient-first routes
  REQUEST_RECIPIENT_DETAILS: null,
  RECEIVED_RECIPIENT_DETAILS: null,

  // loading country data
  REQUEST_COUNTRY_DATA: null,
  RECEIVED_COUNTRY_DATA: null,
  INVALIDATE_COUNTRY_DATA_CACHE: null,

  REDIRECT_TO_XOOM: null,

  // fee related (mostly unused?)
  CHANGE_FEE_TYPE: null,
  LOAD_FEES: null,
  FEES_LOADED: null,
  RECEIVED_FEE: null,

  // errors
  SHOW_ERROR_BANNER: null,
  SHOW_ERROR_PAGE: null,

  // rate stuff (loading)
  CHANGE_ORIGIN_AMOUNT: null,
  CHANGE_DESTINATION_AMOUNT: null,
  CHANGE_AMOUNT: null,

  // rate stuff (loaded)
  REQUEST_ORIGIN_AMOUNT: null,
  RECEIVED_ORIGIN_AMOUNT: null,
  REQUEST_DESTINATION_AMOUNT: null,
  RECEIVED_DESTINATION_AMOUNT: null,
  REQUEST_EXCHANGE_RATE: null,
  RECEIVED_EXCHANGE_RATE: null,

  XB_RECEIVED_GRIFFIN_METADATA: null,

  // xoom interaction stuff
  SET_INITIAL_FLOW_MODEL: null,

  // TODO: Clean up unused ones
  RECEIVED_COUNTRIES: null,
  RECEIVED_RECIPIENT_CODE: null,
  RECEIVED_CONTACTS: null,

  // recipient
  CHANGE_RECIPIENT: null,
  SELECT_CONTACT: null,

  // user
  CHANGE_COUNTRY_INPUT: null,
  FOCUS_COUNTRY_INPUT: null,
  TRIGGER_COUNTRY_DROPDOWN: null,

  // reset
  RESET_TO_INITIAL: null,
})

export const PayloadSources = {
  SERVER_ACTION: 'SERVER_ACTION',
  VIEW_ACTION: 'VIEW_ACTION',
}
